import { Flex, type FlexProps } from '@mantine/core';
import { getCompanyLevelStyles } from '../../model/getCompanyLevelStyles';

type CompanyLevelFlexProps = FlexProps & {
  level?: string | null;
};

export const CompanyLevelFlex = ({
  level,
  style,
  ...props
}: CompanyLevelFlexProps) => (
  <Flex {...props} style={[style, getCompanyLevelStyles(level)]} />
);
